export default __webpack_public_path__ + "static/active_timer2-350da15840b9a368153856a569ca79a5.jpeg";